/*eslint-disable no-duplicate-imports*/
import React, { useEffect, useState, useContext } from "react";
import "./index.css";
import MyContext from "../Mycontext";
import { Collapse, Typography, message } from "antd";
import type { CollapseProps } from "antd";
import { PlusCircleOutlined, MinusCircleFilled } from "@ant-design/icons";
import { CN_TEXT, US_TEXT } from "../../../config";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../providers/CustomThemeProvider";

interface IProps {
	data: string;
	type: string | number;
}

interface IDisplayData {
	input: string;
	label: { [key: string]: number };
}

export const checkIsJSON = (str: string | object): boolean => {
	if (typeof str == "string") {
		try {
			const obj = JSON.parse(str);
			if (typeof obj == "object" && obj) {
				return true;
			} else {
				return false;
			}
		} catch (e) {
			return false;
		}
	}
	return false;
};

const DoctaChatBox = (props: IProps) => {
	const { data, type } = props;
	const [displayData, setDisplayData] = useState<IDisplayData>({
		input: "",
		label: {},
	});
	const [singleMessage, setSingleMessage] = useState<string>("");
	const [qdDisplay, setQdDisplay] = useState<CollapseProps["items"]>([]);
	const [combinedMessage, setCombinedMessage] = useState<string>("");
	const [resType, setResType] = useState<string>("");
	const [subfixMessage, setSubfixMessage] = useState<string>("");
	const { t, i18n } = useTranslation();
	const context = useContext(MyContext);
	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}
	const { isDarkMode, switchTheme } = useTheme();

	const panelStyle: React.CSSProperties = {
		marginBottom: 10,
		background: isDarkMode
			? "rgba(246, 246, 246, 0.29)"
			: "rgba(246, 246, 246, 0.7)",

		borderRadius: 15,
		border: "none",
	};

	useEffect(() => {
		setSingleMessage("");

		try {
			if (checkIsJSON(data)) {
				const parsedData = JSON.parse(data);
				console.log("DoctaChatBox=DoctaChatBox=parsedData, ", parsedData);
				if (parsedData?.status?.response_type) {
					setResType(parsedData?.status?.response_type);
				}

				// parse Query data
				if (type == 1 && parsedData?.data) {
					const qdData = parsedData?.data;

					if (qdData?.error) {
						message.error(qdData?.error?.toString());
					}

					if (
						qdData?.prefix_data_message &&
						qdData?.prefix_data_message != ""
					) {
						setCombinedMessage(qdData?.prefix_data_message);
					}

					if (
						qdData?.subfix_data_message &&
						qdData?.subfix_data_message != ""
					) {
						setSubfixMessage(qdData?.subfix_data_message);
					}

					if (typeof qdData?.single_message == "string") {
						setSingleMessage(qdData?.single_message);
						return;
					}

					if (qdData && typeof qdData === "object" && !Array.isArray(qdData)) {
						const displayList: CollapseProps["items"] = [];
						Object.keys(qdData).map((item, indexOuter) => {
							if (
								typeof qdData[item] === "object" &&
								!Array.isArray(qdData[item])
							) {
								const system = qdData[item]?.system;
								const instruction = qdData[item]?.instruction;
								const response = qdData[item]?.response;
								displayList.push({
									key: indexOuter,
									label: item,
									style: panelStyle,
									children: (
										<Typography>
											<div className="dataset-wrapper">
												{system && (
													<>
														{system}
														<br />
													</>
												)}

												{instruction?.map((item: string, index: number) => {
													return (
														<div className="qa-response" key={index}>
															<p className="qa-response-title">
																数据 {indexOuter + 1}
															</p>
															<div className="qa-response-content">
																<p className="qa-response-content-left">
																	Introduction:
																</p>
																<p className="qa-response-content-right">
																	{/* ML返回的数据会带"Instruction:", "Response:" */}
																	{item?.replace("Instruction:", "")}
																</p>
															</div>

															<div className="qa-response-content">
																<p className="qa-response-content-left">
																	Response:
																</p>
																<p className="qa-response-content-right">
																	{response?.[index]?.replace("Response:", "")}
																</p>
															</div>
															{/* <blockquote>{response?.[index]}</blockquote> */}
														</div>
													);
												})}
											</div>
										</Typography>
									),
								});
							} else {
								if (
									!(
										process.env.REACT_APP_ENV === "production" &&
										item.startsWith("ChatGPT returns")
									)
								) {
									if (
										item != "prefix_data_message" &&
										item != "subfix_data_message" &&
										item != "error"
									) {
										displayList.push({
											key: indexOuter,
											label: item,
											children: qdData[item].toString(),
											style: { border: "none", marginBottom: 10 },
										});
									}
								}
							}
						});
						setQdDisplay(displayList);
					}
				}

				// const result = parsedData?.result;
				const result = parsedData;
				if (result && typeof result === "object" && !Array.isArray(result)) {
					const key = Object.keys(result)?.[0];
					if (key) {
						setDisplayData({
							input: key,
							label: result[key],
						});
					}
				}
			} else {
				setSingleMessage(data);
			}
		} catch (error) {
			console.error("Failed to parse data", error);
		}
	}, [data]);

	const renderLabel = (label: { [key: string]: number }) => {
		return Object.entries(label).map(([key, value]) => (
			<div key={key}>
				<strong>{key}: </strong>
				{typeof value === "number" ? value.toFixed(3) : value}
			</div>
		));
	};

	const isLabelEmpty = (label: { [key: string]: number }) => {
		if (!label) {
			return true;
		}
		return Object.keys(label).length === 0;
	};

	return (
		<div>
			{singleMessage !== "" ? (
				<div> {singleMessage}</div>
			) : type == 1 ? (
				<div className="qdData-color">
					<p className="qdData-color-title">
						{combinedMessage != "" ? (
							combinedMessage
						) : (
							<>{i18n.language == "en" ? CN_TEXT.SOMEDATA : US_TEXT.SOMEDATA}</>
						)}
					</p>
					<Collapse
						defaultActiveKey={
							qdDisplay ? qdDisplay.map((item: any) => item.key)?.[0] : []
						}
						items={qdDisplay}
						bordered={false}
						expandIconPosition="right"
						expandIcon={({ isActive }) => {
							return isActive ? (
								<MinusCircleFilled style={{ fontSize: "20px" }} />
							) : (
								<PlusCircleOutlined style={{ fontSize: "20px" }} />
							);
						}}
					/>
					{subfixMessage != "" ? subfixMessage : <></>}

					{(qdDisplay?.length ?? 0) >= 10 && (
						<div className="qdData-color-title">
							You reached the maximum number of data to display on website,
							please use &quot;want more data&quot; for more data.
						</div>
					)}
				</div>
			) : (
				<>
					<div className="pb-2" style={{ borderBottom: "0.5px solid gray" }}>
						INPUT : {displayData.input}
					</div>
					{isLabelEmpty(displayData.label) ? (
						<div className="pt-2"> Your input is safe</div>
					) : (
						<div className="pt-2">
							RESULTS:
							<div>{renderLabel(displayData.label)}</div>
						</div>
					)}
				</>
			)}
		</div>
	);
};

export default DoctaChatBox;
